// ─────────────────────────────────────────────
//  storage.js — Preferencias persistidas (localStorage)
// ─────────────────────────────────────────────

import { DEFAULTS, CALC_TAB_IDS } from './defaults';

const PREFIX = 'ar-cuanto:';

export const KEYS = {
	theme: 'theme',
	rememberLastTab: 'rememberLastTab',
	lastTab: 'lastTab',
	defaultSection: 'defaultSection',
	defaultTip: 'defaultTip',
	defaultPct: 'defaultPct',
	defaultPctMode: 'defaultPctMode',
	defaultRefGrams: 'defaultRefGrams',
};

export const TAB_IDS = [...CALC_TAB_IDS, 'ajustes'];

export function getSetting(key, fallback = DEFAULTS[key]) {
	try {
		const raw = localStorage.getItem(PREFIX + key);
		if (raw === null) return fallback;
		return JSON.parse(raw);
	} catch {
		return fallback;
	}
}

export function setSetting(key, value) {
	localStorage.setItem(PREFIX + key, JSON.stringify(value));
}

export function removeSetting(key) {
	localStorage.removeItem(PREFIX + key);
}

export function clearAllSettings() {
	Object.values(KEYS).forEach((key) => removeSetting(key));
}

export function resetSettingsToDefaults() {
	Object.entries(DEFAULTS).forEach(([key, value]) => {
		if (KEYS[key]) setSetting(KEYS[key], value);
	});
	removeSetting(KEYS.lastTab);
}

export function getInitialTab() {
	if (getSetting(KEYS.rememberLastTab, DEFAULTS.rememberLastTab)) {
		const last = getSetting(KEYS.lastTab, null);
		if (last && TAB_IDS.includes(last)) return last;
	}

	const section = getSetting(KEYS.defaultSection, DEFAULTS.defaultSection);
	return CALC_TAB_IDS.includes(section) ? section : DEFAULTS.defaultSection;
}
